import { ApiResponseObject } from '@interfaces/api-response/1.0';

export enum CatalogSearchItemType {
  MODIFIER = 'MODIFIER',
  PRODUCT = 'PRODUCT',
  COMPOSITE = 'COMPOSITE',
  COMBO = 'COMBO',
}

export interface CatalogSearchItem {
  catalogEntryId?: string;
  plu?: string;
  itemType?: string;
  name?: string;
  internalName?: string;
  title?: string;
  description?: string;
  decorators?: any;
}

export interface CatalogSearchRequestBody {
  plu?: string;
  itemType?: string;
  query?: string;
  catalogEntryId?: string;
  dataGroupId?: string;
}

export interface CatalogSearchResponse extends ApiResponseObject {
  _embedded: {
    catalog: CatalogSearchItem[];
  };
}
